/* Added the following code for POW-902.Harsha using AI Agent. August 19, 2026. Code Start */
/**
 * Maps permission page IDs to application routes for default-page landing.
 */
export const PAGE_ROUTE_MAP = {
	'1': '/upload/uploadjobs',
	'2': '/upload/managejob',
	'3': '/upload/managecandidates',
	'4': '/organizationalsetup/businessunit',
	'5': '/organizationalsetup/clientjobstatus',
	'6': '/teamlead/manageclient',
	'7': '/teamlead/managevendor',
	'8': '/organizationalsetup/jobstatus',
	'9': '/organizationalsetup/candidatestatus',
	'10': '/organizationalsetup/workauthorization',
	'11': '/organizationalsetup/sourcenames',
	'12': '/organizationalsetup/chatbottype',
	'13': '/securitysetup/managesecurityuser',
	'14': '/securitysetup/managesecurityrole',
	'15': '/upload/manageconsultant',
	'16': '/upload/matchhistory',
	'17': '/upload/chatbothistory',
	'18': '/teamlead/managerecruitersnetwork',
	'19': '/organizationalsetup/employmenttype',
	'20': '/organizationalsetup/managerdetails',
	'21': '/organizationalsetup/setupexpenses',
	'22': '/recruiter/automationdashboard',
	'23': '/analyticsdashboard',
	'24': '/recruiter/dashboard',
	'25': '/teamlead/dashboard',
	'27': '/teamlead/manageVMSPasswords',
	'28': '/match/resume-job-match',
};

/**
 * Sidebar navigation order and labels (matches Navigation.js).
 */
const NAVIGATION_PAGE_ORDER = [
	{ pageId: '23', label: 'Dashboard', url: '/analyticsdashboard' },
	{ pageId: '24', label: 'Dashboard', url: '/recruiter/dashboard' },
	{ pageId: '25', label: 'Dashboard', url: '/teamlead/dashboard' },
	{ pageId: '22', label: 'Automation Dashboard', url: '/recruiter/automationdashboard' },
	{ pageId: '4', label: 'Business Units', url: '/organizationalsetup/businessunit' },
	{ pageId: '5', label: 'Client Job Status', url: '/organizationalsetup/clientjobstatus' },
	{ pageId: '8', label: 'Job Status', url: '/organizationalsetup/jobstatus' },
	{ pageId: '20', label: 'Manager Details', url: '/organizationalsetup/managerdetails' },
	{ pageId: '9', label: 'Candidate Status', url: '/organizationalsetup/candidatestatus' },
	{ pageId: '10', label: 'Work Authorization', url: '/organizationalsetup/workauthorization' },
	{ pageId: '11', label: 'Source Types', url: '/organizationalsetup/sourcenames' },
	{ pageId: '12', label: 'Chatbot Types', url: '/organizationalsetup/chatbottype' },
	{ pageId: '21', label: 'Setup Expenses', url: '/organizationalsetup/setupexpenses' },
	{ pageId: '19', label: 'Employment Types', url: '/organizationalsetup/employmenttype' },
	{ pageId: '13', label: 'Manage Security User', url: '/securitysetup/managesecurityuser' },
	{ pageId: '14', label: 'Manage Security Role', url: '/securitysetup/managesecurityrole' },
	{ pageId: '1', label: 'Upload Job', url: '/upload/uploadjobs' },
	{ pageId: '2', label: 'Manage Jobs', url: '/upload/managejob' },
	{ pageId: '28', label: 'Resume Job Match', url: '/match/resume-job-match' },
	{ pageId: '3', label: 'Manage Candidates', url: '/upload/managecandidates' },
	{ pageId: '15', label: 'Manage Consultants', url: '/upload/manageconsultant' },
	{ pageId: '3', label: 'Applicants', url: '/upload/manageoutsidecandidates' },
	{ pageId: '16', label: 'Match history', url: '/upload/matchhistory' },
	{ pageId: '28', label: 'Job-Resume Match History', url: '/upload/job-resume-match-history' },
	{ pageId: '17', label: 'ChatBot history', url: '/upload/chatbothistory' },
	{ pageId: '6', label: 'Manage Clients', url: '/teamlead/manageclient' },
	{ pageId: '7', label: 'Manage Vendors', url: '/teamlead/managevendor' },
	{ pageId: '27', label: 'Manage VMS Passwords', url: '/teamlead/manageVMSPasswords' },
	{ pageId: '18', label: "Manage Recruiters' Networks", url: '/teamlead/managerecruitersnetwork' },
];

export function buildDefaultPageOptionValue(pageId, url) {
	return `${pageId}::${url}`;
}

export function parseDefaultPageOptionValue(value) {
	if (!value) {
		return { pageId: 0, url: '' };
	}
	const separatorIndex = value.indexOf('::');
	if (separatorIndex === -1) {
		return { pageId: Number(value), url: PAGE_ROUTE_MAP[value] || '' };
	}
	return {
		pageId: Number(value.slice(0, separatorIndex)),
		url: value.slice(separatorIndex + 2),
	};
}

export function getStoredDefaultPageSelection() {
	const pageId = localStorage.getItem('defaultPageId');
	if (!pageId) {
		return '';
	}
	const url = localStorage.getItem('defaultPageUrl') || PAGE_ROUTE_MAP[pageId] || '';
	return url ? buildDefaultPageOptionValue(pageId, url) : pageId;
}

export function getSelectableDefaultPages(pages) {
	const allowedPages = new Set(
		(pages || '').split(',').map((pageId) => pageId.trim()).filter(Boolean)
	);

	return NAVIGATION_PAGE_ORDER
		.filter((entry) => allowedPages.has(entry.pageId))
		.map((entry) => ({
			pageId: entry.pageId,
			label: entry.label,
			url: entry.url,
			value: buildDefaultPageOptionValue(entry.pageId, entry.url),
		}));
}

export function getDefaultLandingRoute(pages, defaultPageId) {
	const allowedPages = new Set(
		(pages || '').split(',').map((pageId) => pageId.trim()).filter(Boolean)
	);
	const selectedPageId = defaultPageId != null && defaultPageId !== '' && defaultPageId !== 0
		? String(defaultPageId)
		: localStorage.getItem('defaultPageId');
	const storedUrl = localStorage.getItem('defaultPageUrl');

	if (selectedPageId && allowedPages.has(selectedPageId)) {
		if (storedUrl) {
			return storedUrl;
		}
		if (PAGE_ROUTE_MAP[selectedPageId]) {
			return PAGE_ROUTE_MAP[selectedPageId];
		}
	}

	if (allowedPages.has('23')) {
		return '/analyticsdashboard';
	}
	if (allowedPages.has('24')) {
		return '/recruiter/dashboard';
	}
	if (allowedPages.has('25')) {
		return '/teamlead/dashboard';
	}
	if (allowedPages.has('22')) {
		return '/recruiter/automationdashboard';
	}

	const firstNavEntry = NAVIGATION_PAGE_ORDER.find((entry) => allowedPages.has(entry.pageId));
	return firstNavEntry ? firstNavEntry.url : '/';
}
/* Code end. Harsha using AI Agent. August 19, 2026 */
